import React, { useState, useEffect, useMemo } from "react";
import { Drawer, IconButton, List, Typography } from "@mui/material";
// import { useTheme } from "@mui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import * as Icons from "@mui/icons-material";
import useStyles from "./styles";
import SidebarLink from "./components/SidebarLink/SidebarLink";
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { whitelabelConfig } from "../../whitelabelConfig/whitelabelConfig";
import { useSelector } from "react-redux";
import { Roles } from "../../util/util";

const structure = [
  { id: 0, type: "divider" },
  { id: 1, label: "Dashboard", link: "/app/dashboard", icon: <Icons.Home /> },
  {
    id: 2,
    label: "Alarms",
    link: "/app/alarms",
    icon: <Icons.NotificationsActive />,
  },
  {
    id: 3,
    label: "Trigger Settings",
    link: "/app/triggers",
    icon: <Icons.Mail />,
  },
  {
    id: 5,
    label: "Device Management",
    link: "/app/deviceManagement/manageDevices",
    icon: <Icons.Settings />,
  },
  { id: 7, type: "divider" },
];

function Sidebar({ location }) {
  const role = localStorage.getItem("role");
  var classes = useStyles();
  // var theme = useTheme();
  const dashboardSettings = useSelector(
    (state) => state.configurationSlice.dashboardConfig
  );

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var layoutState = useLayoutState();
  const [isRemoteeyeUser, setIsRemoteeyeUser] = useState(false);

  // local
  var [isPermanent, setPermanent] = useState(true);
  const [logoImage, setlogoImage] = useState(null);
  const [logoWidth, setlogoWidth] = useState(41);
  const [logoHeight, setlogoHeight] = useState(40);
  const siteDomain = localStorage.getItem("siteDomain");

  useEffect(() => {
    if (
      whitelabelConfig[siteDomain] &&
      whitelabelConfig[siteDomain] !== undefined
    ) {
      setlogoImage(whitelabelConfig[siteDomain].logo);
      setlogoHeight(whitelabelConfig[siteDomain].logoHeight / 2);
      setlogoWidth(whitelabelConfig[siteDomain].logoWidth / 2);
    } else {
      setlogoImage(`${process.env.PUBLIC_URL}/icon.png`);
      setlogoHeight(40);
      setlogoWidth(41);
    }
  }, [siteDomain]);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  const renderSidebar = useMemo(() => {
    let structureList = structure;
    if (role === Roles.OPERATOR) {
      structureList = structureList.filter((link) => link.id !== 3);
    }

    return structureList.map((link, i) => (
      <SidebarLink
        key={i}
        location={location}
        isSidebarOpened={isSidebarOpened}
        {...link}
      />
    ));
  }, [isRemoteeyeUser, role, isSidebarOpened, location]);

  useEffect(() => {
    setIsRemoteeyeUser(
      dashboardSettings?.meta_data?.custom_config?.is_remoteeye_user?.value ||
        false
    );
  }, [dashboardSettings]);

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      {/* <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div> */}
      <div style={{ padding: "8px" }} className={classes.mobileBackButton}>
        <IconButton
          size="large"
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse
          )}
        >
          {layoutState.isSidebarOpened ? (
            <Icons.Close
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                ),
              }}
              style={{ color: "rgb(7, 71, 166)" }}
            />
          ) : (
            <Icons.Dehaze
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                ),
              }}
              style={{ color: "rgb(7, 71, 166)" }}
            />
          )}
        </IconButton>
      </div>
      {isSidebarOpened === true ? (
        <div style={{ marginTop: "5%" }}>
          <img
            style={{ marginLeft: "15%" }}
            alt="icon"
            src={logoImage}
            width={logoWidth}
            height={logoHeight}
          />
          <Typography
            style={{
              marginTop: "5%",
              float: "right",
              marginRight: "25%",
              fontFamily: "'Karla', sans-serif",
              fontWeight: "bold",
            }}
          >
            Hi, {localStorage.getItem("first_name")}
          </Typography>
        </div>
      ) : null}
      <List
        sx={{ padding: "8px", marginTop: "10px" }}
        className={classes.sidebarList}
      >
        {renderSidebar}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    //var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < 1440;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
